export const EnterpriseTranslateMode = {
  NORMAL: 0,
  READ: 2,
  HIGH_FIDELITY: 3,
} as const

export type EnterpriseTranslateModeValue = typeof EnterpriseTranslateMode[keyof typeof EnterpriseTranslateMode]

export function getTranslateEngineDisplayName(engine: any, enterpriseMode = false): string {
  if (!engine) {
    return ''
  }

  const preferredName = enterpriseMode ? engine.engineShowName : engine.engineName
  return String(preferredName || engine.engineName || engine.engineShowName || engine.name || '')
}

export function parseEnterpriseTranslateMode(record: any): number {
  let request = record?.transReqJson

  if (typeof request === 'string') {
    try {
      request = JSON.parse(request)
    } catch {
      return EnterpriseTranslateMode.NORMAL
    }
  }

  const targetType = request?.target_type ?? request?.targetType
  const value = Number(targetType)
  return Number.isFinite(value) ? value : EnterpriseTranslateMode.NORMAL
}

export function isReadModeRecord(record: any): boolean {
  return String(record?.fileType || '').toLowerCase() === 'pdf'
    && parseEnterpriseTranslateMode(record) === EnterpriseTranslateMode.READ
}

export function getReadModeArtifactKey(blobFileName: unknown): string {
  return String(blobFileName || '').replace(/\.[^.]+$/, '')
}
